import { render, staticRenderFns } from "./ImagePoliciesForm.vue?vue&type=template&id=5baba209&scoped=true&"
import script from "./ImagePoliciesForm.vue?vue&type=script&lang=js&"
export * from "./ImagePoliciesForm.vue?vue&type=script&lang=js&"
import style0 from "./ImagePoliciesForm.vue?vue&type=style&index=0&id=5baba209&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baba209",
  null
  
)

export default component.exports